import { render } from "./InfoPopoverIcon.vue?vue&type=template&id=2b18ace7&scoped=true"
import script from "./InfoPopoverIcon.vue?vue&type=script&lang=js"
export * from "./InfoPopoverIcon.vue?vue&type=script&lang=js"

import "./InfoPopoverIcon.vue?vue&type=style&index=0&id=2b18ace7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b18ace7"]])

export default __exports__